export default "__VITE_ASSET__CrF6BwUP__"